// extracted by mini-css-extract-plugin
module.exports = {"main":"layout_main__p9sau","skipLink":"layout_skipLink__S5UTt"};